import {Card, Checkbox} from 'platform/components';
import {Clickable, HStack, Icon, Text, ThemeIconKey} from 'platform/foundation';

import {suffixTestId, TestIdProps} from 'shared/web';

interface RecordAuditResourceCardProps extends TestIdProps {
  icon: ThemeIconKey;
  label: string;
  isSelected: boolean;
  onSelect: () => void;
}

/**
 * Compact selectable card for the create-flow resource step: entity icon + label
 * with a checkbox. Built on the platform Card shell (mirrors the OwnershipSection
 * RadioCard pattern) so chrome comes from the design system. Single-select — the
 * parent handles picking one resource; the checkbox marks the active one.
 */
export function RecordAuditResourceCard(props: RecordAuditResourceCardProps) {
  return (
    <Clickable
      onClick={props.onSelect}
      width="100%"
      data-testid={suffixTestId('resourceCard', props)}
    >
      <Card variant="inlineWhite">
        <HStack spacing={3} align="center">
          <Checkbox
            value={props.isSelected}
            onChange={props.onSelect}
            data-testid={suffixTestId('resourceCard-checkbox', props)}
          />
          <Icon value={props.icon} size={6} color="text.secondary" />
          <Text size="small" data-testid={suffixTestId('resourceCard-label', props)}>
            {props.label}
          </Text>
        </HStack>
      </Card>
    </Clickable>
  );
}
